import PropTypes from 'prop-types'
import { memo } from 'react'
import { Link } from 'react-router-dom'

import styles from './ConversationRow.module.scss'

const ConversationRow = ({
  subscriber,
  active,
  chatId,
  baseUrl,
  category,
  lastMessage
}) => (
  <Link to={`/${baseUrl}/${chatId}`} className={styles.rowLink}>
    <div className={[active ? styles.rowActive : styles.row].join(' ')}>
      <div className={styles.rowLeft}>
        <div className={styles.username}>
          <span className={styles.userFullName}>{subscriber}</span>
          {category && <div className={styles.categoryBubble}>{category}</div>}
        </div>
        <div className={styles.preview}>
          {active ? (
            <span className={styles.yourConversation}>You are on this chat</span>
          ) : (
            <span>{lastMessage}</span>
          )}
        </div>
      </div>
    </div>
  </Link>
)

ConversationRow.propTypes = {
  chatId: PropTypes.number.isRequired,
  baseUrl: PropTypes.string.isRequired,
  subscriber: PropTypes.string.isRequired,
  hotelName: PropTypes.string,
  active: PropTypes.bool
}

export default memo(ConversationRow)
